import { Green } from "./styledCpns/DataDisplay";

export const levels = [
  "1/20",
  "20/20",
  "20/40",
  "40/40",
  "40/50",
  "50/50",
  "50/60",
  "60/60",
  "60/70",
  "70/70",
  "70/80",
  "80/80",
  "80/90",
  "90/90"
];

export const elmtDmgBnes = [
  "Pyro DMG Bonus",
  "Hydro DMG Bonus",
  "Dendro DMG Bonus",
  "Electro DMG Bonus",
  "Anemo DMG Bonus",
  "Cryo DMG Bonus",
  "Geo DMG Bonus"
];

export const baseSTypes = ["HP", "ATK", "DEF"];

export const flatSTypes = ["HP", "ATK", "DEF", "Elemental Mastery"];

export const pctSTypes = [
  "HP%",
  "ATK%",
  "DEF%",
  "CRIT Rate",
  "CRIT DMG",
  "Healing Bonus",
  "Energy Recharge",
  "Shield Strength"
].concat(
  elmtDmgBnes,
  "Physical DMG Bonus",
  "Normal ATK SPD",
  "Charged ATK SPD"
);

export const allOfclSTypes = flatSTypes.concat(pctSTypes);

export const artTypes = ["flower", "plume", "sands", "goblet", "circlet"];

export const artNames = {
  flower: "Flower of Life",
  plume: "Plume of Death",
  sands: "Sands of Eon",
  goblet: "Goblet of Eonothem",
  circlet: "Circlet of Logos"
};

export const charInfoFields = [
  "level",
  "ascension",
  "constellation",
  "Normal Attack",
  "Elemental Skill",
  "Elemental Burst"
];

export const pctOf = (type) => (pctSTypes.includes(type) ? "%" : "");

//----- elements -----//
export const elements = [
  "Pyro",
  "Hydro",
  "Dendro",
  "Electro",
  "Anemo",
  "Cryo",
  "Geo"
];

export const physAndElmts = elements.concat("Physical");

function mapToCharLv(arr) {
  const result = {};
  [1, 20, 40, 50, 60, 70, 80, 90].forEach((lv, i) => {
    result[lv] = arr[i];
  });
  return result;
}

export const baseRxnDmg = mapToCharLv([
  17.17,
  80.58,
  207.38,
  323.6,
  492.88,
  765.64,
  1077.44,
  1446.85
]);

export const swirlables = ["Pyro", "Hydro", "Electro", "Cryo"];
export const crystallizables = ["Pyro", "Hydro", "Electro", "Cryo"];

export const tfmRxns = {
  Bloom: { mult: 2, dmgType: "Dendro" },
  Superconduct: { mult: 0.5, dmgType: "Cryo" },
  Swirl: { mult: 0.6, dmgType: "Various" },
  "Electro-Charged": { mult: 1.2, dmgType: "Electro" },
  Overloaded: { mult: 2, dmgType: "Pyro" },
  Shattered: { mult: 1.5, dmgType: "Physical" },
  Burning: { mult: 0.25, dmgType: "Pyro" },
  Burgeon: { mult: 3, dmgType: "Dendro" },
  Hyperbloom: { mult: 3, dmgType: "Dendro" }
};

export const ampElmts = ["Pyro", "Hydro", "Cryo"];

export const ampRxnTrigElmts = {
  Melt: ["Pyro", "Cryo"],
  Vaporize: ["Pyro", "Hydro"]
};

export const ampMult = {
  melt: (elmt) => (elmt === "Pyro" ? 2 : 1.5),
  vaporize: (elmt) => (elmt === "Pyro" ? 1.5 : 2)
};

export const reactions = Object.keys(tfmRxns).concat(
  Object.keys(ampRxnTrigElmts),
  "aggravate",
  "spread"
);

export const infusePrior = [
  "Pyro",
  "Cryo",
  "Electro",
  "Hydro",
  "Anemo",
  "Physical"
];

export const rsnNames = {
  Dendro: "Sprawling Greenery",
  Hydro: "Soothing Water",
  Pyro: "Fervent Flames",
  Cryo: "Shattering Ice",
  Geo: "Enduring Rock"
};

export const rsnBuffDesc = {
  "Soothing Water": (
    <>
      Increases <Green>Max HP</Green> by <Green b>25%</Green>.
    </>
  ),
  "Sprawling Greenery": (
    <>
      Increases <Green>Elemental Mastery</Green> by <Green b>50</Green>. After
      triggering Burning, Quicken, or Bloom reactions, all nearby party members
      gain <Green>30</Green> <Green>Elemental Mastery</Green> for 6s. After
      triggering Aggravate, Spread, Hyperbloom, or Burgeon reactions, all nearby
      party members gain <Green>20</Green> <Green>Elemental Mastery</Green> for
      6s. The durations of the aforementioned effects will be counted
      independently.
    </>
  ),
  "Fervent Flames": (
    <>
      Increases <Green>ATK</Green> by <Green b>25%</Green>.
    </>
  ),
  "Shattering Ice": (
    <>
      Increases <Green>CRIT Rate</Green> against enemies that are Frozen or
      affected by Cryo by <Green b>15%</Green>.
    </>
  ),
  "Enduring Rock": (
    <>
      Increases <Green>Shield Strength</Green> by <Green b>15%</Green>.
      Increases <Green>DMG</Green> dealt by characters that protected by a
      shield by <Green b>15%</Green>.
    </>
  )
};

export const elmtDebuffDesc = {
  "Enduring Rock": (
    <>
      Shielded characters dealing DMG to enemies will decrease their{" "}
      <Green>Geo RES</Green> by <Green b>20%</Green> for 15s.
    </>
  ),
  Superconduct: (
    <>
      Reduces the <Green>Physical RES</Green> of enemies by <Green b>40%</Green>{" "}
      for 12 seconds.
    </>
  )
};

//----- calculator -----//
export const NAs = ["NA", "CA", "PA"];

const attPatts = ["NA", "CA", "PA", "ES", "EB"];
export const hitBnTypes = ["All", "Elemental", "Physical"].concat(attPatts);
export const bnFields = ["cDmg", "cRate", "flat", "pct", "sMult"];

export const rdAndIg = ["Def", "Physical"]
  .concat(elements)
  .map((a) => `${a}_rd`)
  .concat(attPatts.map((patt) => `${patt}_ig`));

//----- UI -----//

export const wikiImg = (src) =>
  src.split("/")[0] === "https:"
    ? src
    : `https://static.wikia.nocookie.net/gensin-impact/images/${src}.png`;

export const visionIcons = {
  Pyro: "e/e8/Element_Pyro",
  Cryo: "8/88/Element_Cryo",
  Hydro: "3/35/Element_Hydro",
  Electro: "7/73/Element_Electro",
  Anemo: "a/a4/Element_Anemo",
  Geo: "4/4a/Element_Geo",
  Dendro: "f/f4/Element_Dendro"
};

export const weaponIcons = {
  Bow: "9/97/Weapon-class-bow-icon",
  Catalyst: "0/02/Weapon-class-catalyst-icon",
  Claymore: "5/51/Weapon-class-claymore-icon",
  Polearm: "9/91/Weapon-class-polearm-icon",
  Sword: "9/95/Weapon-class-sword-icon"
};

export const artifactIcons = {
  flower: "2/2d/Icon_Flower_of_Life",
  plume: "8/8b/Icon_Plume_of_Death",
  sands: "9/9f/Icon_Sands_of_Eon",
  goblet: "3/37/Icon_Goblet_of_Eonothem",
  circlet: "6/64/Icon_Circlet_of_Logos"
};

export const naIcons = {
  BowPyro: "7/7f/Bow_Pyro",
  BowCryo: "a/a9/Bow_Cryo",
  BowHydro: "6/62/Bow_Hydro",
  BowElectro: "9/98/Bow_Electro",
  BowGeo: "7/71/Bow_Geo",
  BowAnemo: "5/5b/Bow_Anemo",
  BowDendro: "a/a9/Bow_Dendro",
  CatalystPyro: "8/80/Catalyst_Pyro",
  CatalystHydro: "7/77/Catalyst_Hydro",
  CatalystElectro: "e/e7/Catalyst_Electro",
  CatalystGeo: "e/e1/Catalyst_Geo",
  CatalystAnemo: "d/dd/Catalyst_Anemo",
  CatalystDendro: "c/c4/Catalyst_Dendro",
  ClaymorePyro: "5/57/Claymore_Pyro",
  ClaymoreCryo: "9/99/Claymore_Cryo",
  ClaymoreGeo: "6/65/Claymore_Geo",
  ClaymoreElectro: "0/0f/Claymore_Electro",
  ClaymoreAnemo: "c/c7/Claymore_Anemo",
  PolearmPyro: "f/fe/Polearm_Pyro",
  PolearmCryo: "9/91/Polearm_Cryo",
  PolearmHydro: "7/73/Polearm_Hydro",
  PolearmElectro: "0/06/Polearm_Electro",
  PolearmAnemo: "e/ee/Polearm_Anemo",
  PolearmGeo: "9/99/Polearm_Geo",
  SwordPyro: "0/0d/Sword_Pyro",
  SwordCryo: "6/6a/Sword_Cryo",
  SwordHydro: "e/ea/Sword_Hydro",
  SwordElectro: "6/68/Talent_Yunlai_Swordsmanship",
  SwordGeo: "7/79/Sword_Geo",
  SwordAnemo: "0/04/Sword_Anemo",
  SwordDendro: "5/5e/Sword_Dendro"
};
